import { Component } from '@angular/core';

import { DocumentFinderService } from '~/services/document-finder.service';
import { PackExportService } from '~/services/pack-export.service';

@Component({
    selector: 'df-action-bar',
    template: `
    <div class="foot" *ngIf="visible">
      <div class="st2">
        <span><i class="dotc" style="background:var(--green)"></i><b class="n-inc">{{ df.count('inc') }}</b> relevant</span>
        <span><i class="dotc" style="background:#C4302B"></i><b class="n-exc">{{ df.count('exc') }}</b> irrelevant</span>
        <span><i class="dotc" style="background:#D39A2C"></i><b class="n-pend">{{ df.count('pend') }}</b> undecided</span>
        <span *ngIf="df.missing.length"><i class="dotc" style="background:#E08A3C"></i><b class="n-miss">{{ df.missing.length }}</b> reported missing</span>
      </div>
      <span class="sp"></span>
      <span class="hint" *ngIf="df.count('pend') && df.step === 3">Undecided documents will be left out of the pack.</span>
      <button type="button" class="btn back-btn" *ngIf="df.step > 1" (click)="back()">Back</button>
      <button type="button" class="btn pri next-btn" [disabled]="df.count('inc') === 0 || pack.busy" (click)="next()">
        <df-icon *ngIf="df.step === 5" name="up" [size]="15"></df-icon>{{ nextLabel }}
      </button>
    </div>`,
    styleUrls: ['./df-action-bar.component.scss'],
    standalone: false
})
export class DfActionBarComponent {
    constructor(public df: DocumentFinderService, public pack: PackExportService) {}

    public get visible(): boolean {
        return this.df.view === 'search' && this.df.step >= 3 && this.df.step <= 5 && !(this.df.step === 5 && !!this.df.published);
    }

    public get nextLabel(): string {
        if (this.pack.busy) { return 'Preparing ZIP…'; }
        return this.df.step === 3 ? 'Continue to feedback' : this.df.step === 4 ? 'Continue to publish' : 'Publish pack (ZIP)';
    }

    public back(): void {
        this.df.go(this.df.step - 1);
    }

    public next(): void {
        if (this.df.step === 5) {
            void this.pack.publishAndDownload();
        } else {
            this.df.go(this.df.step + 1);
        }
    }
}
